(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations-recently-viewed"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read vars from attributes
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url + '?section_id=product-recommendations-recently-viewed&limit=' + limit + '&product_id=' + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      // set correct image shape
      if(adv_ratio == 'true'){
        var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
        var ar = $firstImage.width() / $firstImage.outerHeight();
        $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
          var thisAr = $(this).width() / $(this).outerHeight();
          if(
            (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
            (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
          ) {
            ar = thisAr;
          }
        });
        if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
          $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
        }
      }
	  const swiper1 = new Swiper('.swiper__product_recommendation', {
		direction: 'horizontal',
        spaceBetween:25,
        slidesPerView:2.49,
        freeMode:true,
        watchSlidesVisibility:true,
        watchSlidesProgress:true,
        scrollbar: { 
            el:'.swiper-scrollbar',
            hide:false,
            draggable:true
        },
        breakpoints:{
            9999:{
            },
            767:{
              slidesPerView:5.49
            }
        },
        // If we need pagination
        //pagination: {
        //    el: '.swiper-pagination',
        //},
        // Navigation arrows
        //navigation: {
        //    nextEl: '.swiper-button-next',
        //    prevEl: '.swiper-button-prev',
        //},
      });

      // init masonry layout
      $(document).trigger('loadmasonry');
    }
  };
  request.send();
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  // Read vars from attributes
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      // set correct image shape
      if(adv_ratio == 'true'){
        var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
        var ar = $firstImage.width() / $firstImage.outerHeight();
        $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
          var thisAr = $(this).width() / $(this).outerHeight();
          if(
            (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
            (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
          ) {
            ar = thisAr;
          }
        });
        if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
          $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
        }
      }

      // init masonry layout
      $(document).trigger('loadmasonry');
    }
  };
  request.send();
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }

  // Read vars from attributes
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;

      // set correct image shape
      if(adv_ratio == 'true'){
        var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
        var ar = $firstImage.width() / $firstImage.outerHeight();
        $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
          var thisAr = $(this).width() / $(this).outerHeight();
          if(
            (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
            (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
          ) {
            ar = thisAr;
          }
        });
        if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
          $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
        }
      }

      // init masonry layout
      $(document).trigger('loadmasonry');
    }
  };
  request.send();
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "related-products") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "related-products") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
